import { render } from "./ReferenceParametersBlock.vue?vue&type=template&id=695d3ba8&scoped=true"
import script from "./ReferenceParametersBlock.vue?vue&type=script&lang=js"
export * from "./ReferenceParametersBlock.vue?vue&type=script&lang=js"

import "./ReferenceParametersBlock.vue?vue&type=style&index=0&id=695d3ba8&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695d3ba8"]])

export default __exports__